import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from '@/lib/axios'
import { HYDRATE } from 'next-redux-wrapper'

function isHydrateAction(action) {
    return action.type === HYDRATE
}

function normalizeMembershipResponse(response) {
    return response?.data ?? response?.result ?? response
}

export const membershipApi = createApi({
    reducerPath: 'membershipApi',
    baseQuery: axiosBaseQuery(),
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    keepUnusedDataFor: 0,
    extractRehydrationInfo(action, { reducerPath }) {
        if (isHydrateAction(action) && action.payload?.[reducerPath]) {
            return action.payload[reducerPath]
        }
    },
    endpoints: (builder) => ({
        getMembershipConsumption: builder.query({
            query: () => ({
                method: 'GET',
                url: `/membership/consumption`,
            }),
            keepUnusedDataFor: 0,
            transformResponse: normalizeMembershipResponse,
        }),
        getMembershipPackageDetails: builder.query({
            query: () => ({
                method: 'GET',
                url: `/membership/package`,
            }),
            keepUnusedDataFor: 0,
            transformResponse: normalizeMembershipResponse,
        }),
        getMembershipDetails: builder.query({
            query: (options = {}) => ({
                method: 'GET',
                url: `/membership`,
                skipAuthRedirect: options.skipAuthRedirect,
            }),
            keepUnusedDataFor: 0,
            transformResponse: normalizeMembershipResponse,
        }),

        getMembershipIntent: builder.mutation({
            query: (paymentData = {}) => ({
                method: 'POST',
                url: `/membership/create-intent`,
                data: paymentData,
            }),
            transformResponse: normalizeMembershipResponse,
        }),
        applyMembershipPromotionCode: builder.mutation({
            query: ({ code }) => ({
                method: 'POST',
                url: `/membership/apply-promotion-code`,
                data: { code },
            }),
            transformResponse: normalizeMembershipResponse,
        }),
        misapplyMembershipPromotionCode: builder.mutation({
            query: () => ({
                method: 'POST',
                url: `/membership/misapply-promotion-code`,
            }),
            transformResponse: normalizeMembershipResponse,
        }),
        buySubscription: builder.mutation({
            query: (paymentData) => ({
                method: 'POST',
                url: `/membership/subscribe`,
                data: paymentData
            }),
            transformResponse: normalizeMembershipResponse,
        }),
        cancel: builder.mutation({
            query: () => ({
                method: 'POST',
                url: `/membership/cancel`,
            }),
            transformResponse: normalizeMembershipResponse,
        }),
    }),

})

export const {
    useApplyMembershipPromotionCodeMutation,
    useGetMembershipConsumptionQuery,
    useGetMembershipIntentMutation,
    useGetMembershipPackageDetailsQuery,
    useGetMembershipDetailsQuery,
    useMisapplyMembershipPromotionCodeMutation,
    useBuySubscriptionMutation,
    useCancelMutation,

} = membershipApi
